function capitalize(s)
{
    return String(s[0]).toUpperCase() + String(s).slice(1);
}

function basename(path)
{
    return path.split('/').reverse()[0];
}

function makesingular(name)
{
    if (name.endsWith('ies')) {
        return name.slice(0, -3) + 'y';
    } else if (name.endsWith('s')) {
        return name.slice(0, -1);
    }
    return name;
}

function convertdate(datetimestring) {
    return new Date(datetimestring).toLocaleString("en-US", {
        year: "numeric",   // 2025
        month: "short",    // Jan
        day: "2-digit",    // 13
        hour: "2-digit",   // 10
        minute: "2-digit", // 37
        second: "2-digit", // 25
        hour12: false      // Use 24-hour format
      })
}

function convertdatenotime(datetimestring) {
    return new Date(datetimestring).toLocaleString("en-US", {
        year: "numeric",   // 2025
        month: "short",    // Jan
        day: "2-digit",    // 13
      })
}

function sum( arr ){
    return arr.reduce((partialSum, a) => partialSum + a, 0);
  };

export { capitalize, basename, makesingular, convertdate, convertdatenotime, sum };